import { IPublicClientApplication } from '@azure/msal-browser';
import { DiscrepancyReport } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { createDiscrepancyReport } from './index';

export const createDiscrepancyReportApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  createDiscrepancyReport: (instance: IPublicClientApplication, discrepancyReport: DiscrepancyReport) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createDiscrepancyReport(fetchContext, discrepancyReport, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createDiscrepancyReport', isInFlight);
    },
  ),
});
